package kz.dentalcrm.app.screens.quick_replies.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

sealed interface EditQuickReplyViewEvent : ViewEvent {
    data class EditQuickReply(val quickReply: QuickReply, val message: String) : EditQuickReplyViewEvent
    data class DeleteQuickReply(val quickReply: QuickReply) : EditQuickReplyViewEvent
    data object Reset : EditQuickReplyViewEvent
}
